// node modules
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

// app modules: components
import ContentOptions from 'components/ContentOptions';
import Icon from 'components/Icon';

// app modules: props
import AuthorsProps from 'components/Authors/AuthorsProps';

// app modules: constants
import { COLOURS } from 'constants/index';

class ContentOptionsAsButton extends PureComponent {
  static propTypes = {
    authors: AuthorsProps.authors,
    itemId: PropTypes.string.isRequired,
    itemType: PropTypes.string.isRequired,
    hideText: PropTypes.bool,
  };

  static defaultProps = {
    authors: [],
    hideText: false,
  };

  render() {
    const { hideText } = this.props;
    const icon = <Icon fill={COLOURS.ENERGIZED} name="list-add" height="20" width="20" />;
    return (
      <ContentOptions
        buttonProps={{
          startIcon: hideText ? null : icon,
        }}
        {...this.props}
      >
        {hideText ? (
          icon
        ) : (
          <React.Fragment>
            <span className="hide-on-narrow-mobile">Add to&nbsp;</span>collection
          </React.Fragment>
        )}
      </ContentOptions>
    );
  }
}

export default ContentOptionsAsButton;
